import type {ReactNode} from 'react'
import {LockIcon} from '@primer/octicons-react'
import styles from './BlockedTaskInput.module.css'

interface BlockedTaskInputProps {
  /** The message to display explaining why input is blocked */
  children: ReactNode
}

/**
 * Presentational component for displaying a blocked/disabled state in chat inputs.
 * Shows a lock icon alongside a message explaining why input is unavailable.
 */
export function BlockedTaskInput({children}: BlockedTaskInputProps) {
  return (
    <div className={styles.blockedContainer}>
      <div className={styles.blockedContent}>
        <LockIcon size={16} className={styles.blockedIcon} />
        <p className={styles.blockedText}>{children}</p>
      </div>
    </div>
  )
}
